export const productsData = [{
        id: '1',
        proName: "BOSSINI Men",
        proImg: "/assets/Men/products/jacket-1.jpg",
        proDesc: "",
        proPrice: "956",
        category: "men",
        proSelect: "Jackets",
        block2: "/assets/Men/products/menCol/jacket/jacket-2.jpg",
        block3: "/assets/Men/products/menCol/jacket/jacket-3.jpg",
        block4: "/assets/Men/products/menCol/jacket/jacket-4.jpg",
        block5: "/assets/Men/products/menCol/jacket/jacket-5.jpg",
    },
    {
        id: '2',
        proName: "FLYIN MACHINE",
        proImg: "/assets/Men/products/jean-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Jeans",
        block2: "/assets/Men/products/menCol/jean/jean-2.jpg",
        block3: "/assets/Men/products/menCol/jean/jean-3.jpg",
        block4: "/assets/Men/products/menCol/jean/jean-4.jpg",
        block5: "/assets/Men/products/menCol/jean/jean-5.jpg",
    },
    {
        id: '3',
        proName: "JACK & JONES",
        proImg: "/assets/Men/products/mcg-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Cargo's",
        block2: "/assets/Men/products/menCol/mcg/mcg-2.jpg",
        block3: "/assets/Men/products/menCol/mcg/mcg-3.jpg",
        block4: "/assets/Men/products/menCol/mcg/mcg-4.jpg",
        block5: "/assets/Men/products/menCol/mcg/mcg-5.jpg",
    },
    {
        id: '4',
        proName: "FAREN HEIT",
        proImg: "/assets/Men/products/mcasual-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Men Casuals",
        block2: "/assets/Men/products/menCol/mcasual/mcasual-2.jpg",
        block3: "/assets/Men/products/menCol/mcasual/mcasual-3.jpg",
        block4: "/assets/Men/products/menCol/mcasual/mcasual-4.jpg",
        block5: "/assets/Men/products/menCol/mcasual/mcasual-5.jpg",
    },
    {
        id: '5',
        proName: "FAME FOREVER",
        proImg: "/assets/Men/products/mcs-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Casual Shirts",
        block2: "/assets/Men/products/menCol/mcs/mcs-2.jpg",
        block3: "/assets/Men/products/menCol/mcs/mcs-3.jpg",
        block4: "/assets/Men/products/menCol/mcs/mcs-4.jpg",
        block5: "/assets/Men/products/menCol/mcs/mcs-5.jpg",
    },
    {
        id: '6',
        proName: "BLACK BERRY",
        proImg: "/assets/Men/products/mf-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Formals",
        block2: "/assets/Men/products/menCol/mf/mf-2.jpg",
        block3: "/assets/Men/products/menCol/mf/mf-3.jpg",
        block4: "/assets/Men/products/menCol/mf/mf-4.jpg",
        block5: "/assets/Men/products/menCol/mf/mf-5.jpg",
    },
    {
        id: '7',
        proName: "SMILEY WORLD",
        proImg: "/assets/Men/products/mft-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "T-shirts",
        block2: "/assets/Men/products/menCol/mft/mft-2.jpg",
        block3: "/assets/Men/products/menCol/mft/mft-3.jpg",
        block4: "/assets/Men/products/menCol/mft/mft-4.jpg",
        block5: "/assets/Men/products/menCol/mft/mft-5.jpg",
    },
    {
        id: '8',
        proName: "KAPPA Men",
        proImg: "/assets/Men/products/mhd-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Hoodies",
        block2: "/assets/Men/products/menCol/mhd/mhd-2.jpg",
        block3: "/assets/Men/products/menCol/mhd/mhd-3.jpg",
        block4: "/assets/Men/products/menCol/mhd/mhd-4.jpg",
        block5: "/assets/Men/products/menCol/mhd/mhd-5.jpg",
    },
    {
        id: '9',
        proName: "U.S.POLO",
        proImg: "/assets/Men/products/mj-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Jeans",
        block2: "/assets/Men/products/menCol/mj/mj-2.jpg",
        block3: "/assets/Men/products/menCol/mj/mj-3.jpg",
        block4: "/assets/Men/products/menCol/mj/mj-4.jpg",
        block5: "/assets/Men/products/menCol/mj/mj-5.jpg",
    },
    {
        id: '10',
        proName: "UNITED COLORS",
        proImg: "/assets/Men/products/mjc-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Jackets",
        block2: "/assets/Men/products/menCol/mjc/mjc-2.jpg",
        block3: "/assets/Men/products/menCol/mjc/mjc-3.jpg",
        block4: "/assets/Men/products/menCol/mjc/mjc-4.jpg",
        block5: "/assets/Men/products/menCol/mjc/mjc-5.jpg",
    },
    {
        id: '11',
        proName: "FARENHEIT",
        proImg: "/assets/Men/products/mps-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Pants",
        block2: "/assets/Men/products/menCol/mps/mps-2.jpg",
        block3: "/assets/Men/products/menCol/mps/mps-3.jpg",
        block4: "/assets/Men/products/menCol/mps/mps-4.jpg",
        block5: "/assets/Men/products/menCol/mps/mps-5.jpg",
    },
    {
        id: '12',
        proName: "MELANGE",
        proImg: "/assets/Men/products/mrn-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "T-shirts",
        block2: "/assets/Men/products/menCol/mrn/mrn-2.jpg",
        block3: "/assets/Men/products/menCol/mrn/mrn-3.jpg",
        block4: "/assets/Men/products/menCol/mrn/mrn-4.jpg",
        block5: "/assets/Men/products/menCol/mrn/mrn-5.jpg",
    },
    {
        id: '13',
        proName: "M SPORT",
        proImg: "/assets/Men/products/msp-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "Sports Wear",
        block2: "/assets/Men/products/menCol/msp/msp-2.jpg",
        block3: "/assets/Men/products/menCol/msp/msp-3.jpg",
        block4: "/assets/Men/products/menCol/msp/msp-4.jpg",
        block5: "/assets/Men/products/menCol/msp/msp-5.jpg",
    },
    {
        id: '14',
        proName: "PROLINE",
        proImg: "/assets/Men/products/t-shirt-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "men",
        proSelect: "T-shirts",
        block2: "/assets/Men/products/menCol/t-shirt/t-shirt-2.jpg",
        block3: "/assets/Men/products/menCol/t-shirt/t-shirt-3.jpg",
        block4: "/assets/Men/products/menCol/t-shirt/t-shirt-4.jpg",
        block5: "/assets/Men/products/menCol/t-shirt/t-shirt-5.jpg",
    },
]

export const womanProducts = [{
        id: '15',
        proName: "FABALLEY",
        proImg: "/assets/Woman/products/wa-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Skirts",
        block2: "/assets/Woman/products/wCol/wa/wa-2.jpg",
        block3: "/assets/Woman/products/wCol/wa/wa-3.jpg",
        block4: "/assets/Woman/products/wCol/wa/wa-4.jpg",
        block5: "/assets/Woman/products/wCol/wa/wa-5.jpg",
    },
    {
        id: '16',
        proName: "GINGER",
        proImg: "/assets/Woman/products/wb-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Skirts",
        block2: "/assets/Woman/products/wCol/wb/wb-2.jpg",
        block3: "/assets/Woman/products/wCol/wb/wb-3.jpg",
        block4: "/assets/Woman/products/wCol/wb/wb-4.jpg",
        block5: "/assets/Woman/products/wCol/wb/wb-5.jpg",
    },
    {
        id: '17',
        proName: "FAME FOREVER",
        proImg: "/assets/Woman/products/wc-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Shirts",
        block2: "/assets/Woman/products/wCol/wc/wc-2.jpg",
        block3: "/assets/Woman/products/wCol/wc/wc-3.jpg",
        block4: "/assets/Woman/products/wCol/wc/wc-4.jpg",
        block5: "/assets/Woman/products/wCol/wc/wc-5.jpg",
    },
    {
        id: '18',
        proName: "DE MOZA",
        proImg: "/assets/Woman/products/wd-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Jeans",
        block2: "/assets/Woman/products/wCol/wd/wd-2.jpg",
        block3: "/assets/Woman/products/wCol/wd/wd-3.jpg",
        block4: "/assets/Woman/products/wCol/wd/wd-4.jpg",
        block5: "/assets/Woman/products/wCol/wd/wd-5.jpg",
    },
    {
        id: '19',
        proName: "KAPPA",
        proImg: "/assets/Woman/products/we-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Sarees",
        block2: "/assets/Woman/products/wCol/we/we-2.jpg",
        block3: "/assets/Woman/products/wCol/we/we-3.jpg",
        block4: "/assets/Woman/products/wCol/we/we-4.jpg",
        block5: "/assets/Woman/products/wCol/we/we-5.jpg",
    },
    {
        id: '20',
        proName: "VERO MODA",
        proImg: "/assets/Woman/products/wf-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Jeans",
        block2: "/assets/Woman/products/wCol/wf/wf-2.jpg",
        block3: "/assets/Woman/products/wCol/wf/wf-3.jpg",
        block4: "/assets/Woman/products/wCol/wf/wf-4.jpg",
        block5: "/assets/Woman/products/wCol/wf/wf-5.jpg",
    },
    {
        id: '21',
        proName: "FABALLEY",
        proImg: "/assets/Woman/products/wg-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Jackets",
        block2: "/assets/Woman/products/wCol/wg/wg-2.jpg",
        block3: "/assets/Woman/products/wCol/wg/wg-3.jpg",
        block4: "/assets/Woman/products/wCol/wg/wg-4.jpg",
        block5: "/assets/Woman/products/wCol/wg/wg-5.jpg",
    },
    {
        id: '22',
        proName: "OSSINI",
        proImg: "/assets/Woman/products/wh-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Tops",
        block2: "/assets/Woman/products/wCol/wh/wh-2.jpg",
        block3: "/assets/Woman/products/wCol/wh/wh-3.jpg",
        block4: "/assets/Woman/products/wCol/wh/wh-4.jpg",
        block5: "/assets/Woman/products/wCol/wh/wh-5.jpg",
    },
    {
        id: '23',
        proName: "ABBIDE",
        proImg: "/assets/Woman/products/wi-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Party Wear",
        block2: "/assets/Woman/products/wCol/wi/wi-2.jpg",
        block3: "/assets/Woman/products/wCol/wi/wi-3.jpg",
        block4: "/assets/Woman/products/wCol/wi/wi-4.jpg",
        block5: "/assets/Woman/products/wCol/wi/wi-5.jpg",
    },
    {
        id: '24',
        proName: "SEMENS",
        proImg: "/assets/Woman/products/wj-1.jpg",
        proDesc: "",
        proPrice: "",
        category: "woman",
        proSelect: "Chudidars",
        block2: "/assets/Woman/products/wCol/wjwj-2.jpg",
        block3: "/assets/Woman/products/wCol/wjwj-3.jpg",
        block4: "/assets/Woman/products/wCol/wjwj-4.jpg",
        block5: "/assets/Woman/products/wCol/wjwj-5.jpg",
    },
]